import { render, staticRenderFns } from "./EditSupplierQuality.vue?vue&type=template&id=64306be8&scoped=true"
import script from "./EditSupplierQuality.vue?vue&type=script&lang=js"
export * from "./EditSupplierQuality.vue?vue&type=script&lang=js"
import style0 from "./EditSupplierQuality.vue?vue&type=style&index=0&id=64306be8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64306be8",
  null
  
)

export default component.exports